import { hexToRgb } from "./helpers";
import { useCallback } from "react";
import shortid from "shortid";

export const getSegmentBackgroundColor = (color) => {
  const [r, g, b] = hexToRgb(color);
  return `rgba(${r},${g},${b},0.2)`;
};

// Utility function to generate a clone tree
export const useClone = (query, actions) => {
  const getCloneTree = useCallback(
    (idToClone) => {
      const tree = query.node(idToClone).toNodeTree();
      const newNodes = {};

      const changeNodeId = (node, newParentId) => {
        const newNodeId = shortid.generate();
        const childNodes = node.data.nodes.map((childId) =>
          changeNodeId(tree.nodes[childId], newNodeId)
        );
        const linkedNodes = Object.keys(node.data.linkedNodes).reduce(
          (accum, id) => {
            const linkedNodeId = changeNodeId(
              tree.nodes[node.data.linkedNodes[id]],
              newNodeId
            );
            return {
              ...accum,
              [id]: linkedNodeId,
            };
          },
          {}
        );

        let tmpNode = {
          ...node,
          id: newNodeId,
          data: {
            ...node.data,
            parent: newParentId || node.data.parent,
            nodes: childNodes,
            linkedNodes,
          },
        };
        let freshnode = query.parseFreshNode(tmpNode).toNode();
        newNodes[newNodeId] = freshnode;
        return newNodeId;
      };

      const rootNodeId = changeNodeId(tree.nodes[tree.rootNodeId]);
      return {
        rootNodeId,
        nodes: newNodes,
      };
    },
    [query]
  );

  const handleClone = (e, id) => {
    e.preventDefault();
    const theNode = query.node(id).get();
    const parentNode = query.node(theNode.data.parent).get();
    const indexToAdd = parentNode.data.nodes.indexOf(id);
    const tree = getCloneTree(id);
    actions.addNodeTree(tree, parentNode.id, indexToAdd + 1);

    // Select the newly cloned node to make it active
    actions.selectNode(tree.rootNodeId);
  };

  return { handleClone };
};
